import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { eventDocumentTemplateService } from "../../_services/eventDocumentTemplate.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const EventDocumentTemplateAutoComplete = (params: IStandardExtAutocomplete) => {

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={eventDocumentTemplateService.getDropdown}
            label={"Event Document Template Select"} />
    );
}